import {cache, inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetModelDetailFormConfigUseCase extends UseCase {
  constructor({repository}) {
    super()
    this._repository = repository
  }

  @tracer({metric: 'GetModelDetailFormConfigUseCase#execute'})
  @cache({ttl: '10 minutes', server: true})
  @inlineError
  execute({makeId}) {
    return this._repository
      .getModelDetailFormConfig({makeId})
      .then(([getModelDetailFormConfigError, getModelDetailFormConfigValueObject]) => {
        if (getModelDetailFormConfigError) return Promise.reject(getModelDetailFormConfigError)
        return getModelDetailFormConfigValueObject.toJSON()
      })
  }
}
